import React from 'react';

/**
 * Shared satisFIND® logo. Always references the local asset at
 * /satisfind-logo.png so we can update the file in `public/` without
 * touching call sites.
 *
 * Props:
 *   size    – pixel width (default 140); height auto to preserve ratio
 *   variant – 'default' (dark bg friendly) | 'compact' (for tight headers, 32px tall)
 */
export default function SatisfindLogo({ size = 140, variant = 'default', className = '', alt = 'satisFIND', ...rest }) {
  const height = variant === 'compact' ? 32 : undefined;
  const width = variant === 'compact' ? undefined : size;
  return (
    <img
      src="/satisfind-logo.png"
      alt={alt}
      className={className}
      style={{
        width: width ? `${width}px` : 'auto',
        height: height ? `${height}px` : 'auto',
        objectFit: 'contain',
      }}
      {...rest}
    />
  );
}
